import type { ClassValue } from 'clsx';
import { clsx } from 'clsx';
import { extendTailwindMerge, twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function configureCn(twMergeConfig: Parameters<typeof extendTailwindMerge>[0]) {
  const twMerge = extendTailwindMerge(twMergeConfig);

  return (...inputs: ClassValue[]) => twMerge(clsx(inputs));
}
